import { Typography } from "@mui/material";
import { Container } from "@mui/system";
import TextCard from "../../TextCard";
import SectionImage, {
  hasSectionImage,
} from "pages/Courses/AdquireCourse/Sections/SectionImage";
import { isEnabled } from "utils/booleans";

const RecommendedTo = ({ props }) => {
  const {
    show_section4,
    recommendedTo,
    section4_title,
    section4_bgColor_1,
    section4_bgColor_2,
    section4_use_image,
    section4_image,
    section4_mobile_image,
  } = props;

  if (!isEnabled(show_section4)) return null;
  if (
    section4_use_image &&
    hasSectionImage(section4_image, section4_mobile_image)
  ) {
    return (
      <SectionImage
        image={section4_image}
        mobileImage={section4_mobile_image}
        alt="Curso indicado para"
      />
    );
  }

  return (
      <section
        style={{
          padding: "6rem 0",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          background: `linear-gradient(180deg, ${section4_bgColor_1} 0%, ${section4_bgColor_2} 100%)`,
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "4rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              color: "black",
            }}
          >
            Seção 3
          </Typography>

          <Typography
            variant="h2"
            sx={{
              marginBottom: "1rem",
            }}
            dangerouslySetInnerHTML={{ __html: section4_title }}
          />

          <Typography
            variant="h2"
            sx={{
              marginBottom: "1rem",
            }}
            dangerouslySetInnerHTML={{ __html: recommendedTo }}
          />

          {/* <div
            style={{
              display: "flex",
              gap: "2rem",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {recommendedTo !== undefined &&
              recommendedTo !== null &&
              recommendedTo.map((user, index) => (
                <TextCard key={index} text={user["name"]} />
              ))}
          </div> */}
        </Container>
      </section>
  );
};

export default RecommendedTo;
